export default __webpack_public_path__ + "static/burrededge-2899d0a216f85b0bbb9a955bca3f20b1.png";